import React from 'react';
import debounce from 'debounce';

import {
    AutoComplete
} from 'antd';

import {
    _getBuyers,
    _getSellers,
    _getAllFlatCategories,
    _getPageTypes,
    _getAllBrands
} from '../../services'

class Search extends React.Component {

    constructor(props) {
        super(props)
        
        if (this.props.type === "buyer") {
            _getBuyers()
            .then(res => {
                this.setState({
                    dataSource: res.data.listOfBuyers
                })
            })
        }
        if (this.props.type === "seller") {
            _getSellers()
            .then(res => {
                this.setState({
                    dataSource: res.data.listOfSellers
                })
            })
        }
        if (this.props.type === "supplierSearchByCategory") {
            Promise.all([
                _getAllFlatCategories(),
                _getAllBrands()
            ])
            .then(([_flatCategories, _brands]) => {

                // Combine flat categories and brands
                var dataSource = []
                _flatCategories.data._flatCategories.map(_flatCategory => dataSource.push(_flatCategory.titleUrl))
                _brands.data.brands.map(_brand => dataSource.push(_brand.kebabName))

                this.setState({
                    dataSource
                })
            })
        }

        if (this.props.type == "marketing") {
            _getPageTypes()
            .then(res => {
                this.setState({
                    dataSource: res.data
                })
            })
        }

        this.state = {
            value: this.props.value || '',
        };

        this.onSearch = debounce(this.onSearch, 400);
    }
    
    render() {

        const { dataSource, value } = this.state;

        return (
            <AutoComplete
                value={value}
                dataSource={dataSource}
                style={{ width: 400 }}
                onSelect={this.onSelect}
                onSearch={this.onSearch}
                onChange={this.onChange}
                filterOption={(inputValue, option) =>
                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                placeholder="Search"
            />
        );
    }

    onSearch = searchText => {

    };

    onChange = value => {
        this.setState({ value });
    };

    onSelect = (value) => {
        this.props.onSelect(value)
    }



}

export default Search


// WEBPACK FOOTER //
// ./src/components/explore/search.js